import { observer } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { Loader } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.scss';

const OfflineStatus = ({ children }) => {
  const presenter = usePresenter();
  const { t } = useTranslation();

  if (!presenter.isOfflineNetworkStatus) {
    return children || null;
  }

  return (
    <span className={styles.container}>
      <Loader
        className={styles.loader}
        color="secondary"
      />
      {t('common_no_internet')}
    </span>
  );
};

export default observer(OfflineStatus);
